export const genderOptions = [
    { text: 'insuranceForm:insurance_form.gender.man', value: 'M' },
    { text: 'insuranceForm:insurance_form.gender.woman', value: 'W' },
    { text: 'insuranceForm:insurance_form.gender.non-binary', value: 'N' },
    { text: 'insuranceForm:insurance_form.gender.prefer-not-to-say', value: 'P' },
];
